export const GHG_STEPS = {
  FARM_DETAIL: {
    id: 'farm-detail',
    title: 'Your farm',
  },
  LIVESTOCK_BALANCES: {
    id: 'livestock-balances',
    title: 'Livestock balances',
  },
  GRAZING_MOVEMENTS: {
    id: 'grazing-movements',
    title: 'Grazing movements',
  },
  LIVESTOCK_MOVEMENTS: {
    id: 'livestock-movements',
    title: 'Livestock movements',
  },
  RESULT: {
    id: 'result',
    title: 'Results',
  },
} as const
export type GhgNavStep = typeof GHG_STEPS[keyof typeof GHG_STEPS]

export const GHG_STEPS_SEQUENCE = [
  GHG_STEPS.FARM_DETAIL,
  GHG_STEPS.LIVESTOCK_BALANCES,
  GHG_STEPS.GRAZING_MOVEMENTS,
  GHG_STEPS.LIVESTOCK_MOVEMENTS,
  GHG_STEPS.RESULT,
] as const

export function findNextStep(currentStep: GhgNavStep): GhgNavStep | null {
  return (
    GHG_STEPS_SEQUENCE.find((_step, idx, allSteps) => allSteps[idx - 1]?.id === currentStep.id) ??
    null
  )
}

export function findPreviousStep(currentStep: GhgNavStep): GhgNavStep | null {
  return (
    GHG_STEPS_SEQUENCE.find((_step, idx, allSteps) => allSteps[idx + 1]?.id === currentStep.id) ??
    null
  )
}
